import { EndpointTypes } from 'models/endpoint';
import InteractionType, { baseInteractionType } from 'models/interaction_type';

const ENDPOINT_BY_INTERACTION = Object.freeze({
  [InteractionType.CHAT]: EndpointTypes.CHAT,
  [InteractionType.CUSTOM_CHANNEL]: EndpointTypes.CUSTOM_CHANNEL,
  [InteractionType.EMAIL]: EndpointTypes.EMAIL,
  [InteractionType.FB_COMMENT]: EndpointTypes.FB_COMMENT,
  [InteractionType.INSTAGRAM_COMMENT]: EndpointTypes.INSTAGRAM_COMMENT,
  [InteractionType.INSTAGRAM_DIRECT]: EndpointTypes.INSTAGRAM_DIRECT,
  [InteractionType.SMS]: EndpointTypes.SMS,
  [InteractionType.FB_MESSENGER]: EndpointTypes.FB_MESSENGER,
  [InteractionType.WHATSAPP]: EndpointTypes.WHATSAPP,
  [InteractionType.TWITTER]: EndpointTypes.TWITTER,
  [InteractionType.PHONE_CALL]: EndpointTypes.VOICE,
  [InteractionType.VOICEMAIL]: EndpointTypes.VOICE,
  [InteractionType.ABANDONED_CALL]: EndpointTypes.VOICE,
});

export function endpointChannelForInteractionType(interactionType) {
  return ENDPOINT_BY_INTERACTION[baseInteractionType(interactionType)];
}
